import api from "./base-api"

const mcArchiveApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getArchivedStateV2MC: build.query({
            query: (userId = "") => `v2/mc/archive/${userId}`
        }),
        archiveStateV2MC: build.mutation({
            query: (userId = "") => ({
                url: `v2/mc/archive/${userId}`,
                method: "POST"
            })
        }),
        restoreArchivedStateV2MC: build.mutation({
            query: (data = "") => ({
                url: `v2/mc/archive/${data.userId}/restore`,
                method: "POST"
            })
        }),
        deleteArchivedStateV2MC: build.mutation({
            query: (userId = "") => ({
                url: `v2/mc/archive/${userId}`,
                method: "DELETE"
            })
        })
    }),
    overrideExisting: false
})

export const {
    useGetArchivedStateV2MCQuery,
    useArchiveStateV2MCQuery,
    useRestoreArchivedStateV2MCMutation,
    useDeleteArchivedStateV2MCQuery
} = mcArchiveApiV2
